





























































































































































































import { Component, Mixins } from 'vue-property-decorator';

// Node module imports
import { View } from 'client-website-ts-library/plugins';

import { Map } from 'client-website-ts-library/components';

import { ListingFilter, ProfileFilter } from 'client-website-ts-library/filters';

import {
  ListingStatus,
  Office,
  MapSettings,
  MapMarker,
  WebsiteLevel,
  Profile,
  WebsiteProfileDisplayType,
  ListingCategory,
} from 'client-website-ts-library/types';

import {
  API,
  Config,
  Logger,
  LogLevel,
} from 'client-website-ts-library/services';

// Vue imports
import { ItemCyclerSlide, ItemCyclerImageSlide } from '../app_code/ItemCycler';
import ItemCycler from '../components/Cycler/ItemCycler.vue';
import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';
import PhotoRow from '../components/Layout/PhotoRow.vue';
import Form from '../components/Forms/Form.vue';
import ProfileCards from '../components/ProfileCards.vue';
import OwnerCards from '../components/OwnerCards.vue';

@Component({
  components: {
    ItemCycler,
    Listings,
    ListingSearch,
    Map,
    PhotoRow,
    Form,
    ProfileCards,
    OwnerCards,
  },
})
export default class Home extends Mixins(View) {
  private office: Office | null = null;

  private profiles: Profile[] | null = null;

  private modalActive = true;

  private mapSettings: MapSettings | null = null;

  private cyclerImages: ItemCyclerSlide[] = [
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/1',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/2',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/3',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/home/slider/4',
      formats: ['avif', 'webp', 'jpg'],
      fallback: 'jpg',
    }),
  ];

  private listingFilter: ListingFilter = new ListingFilter({
    Statuses: [ListingStatus.Current, ListingStatus.UnderContract],
    /* Categories: [ListingCategory.ResidentialSale, ListingCategory.ResidentialLand], */
    PageSize: 6,
  });

  mounted() {
    this.loadOffice();
    this.loadProfiles();
  }

  loadProfiles(): void {
    API.Profiles.Search(new ProfileFilter()).then((profiles) => {
      this.profiles = profiles.filter((p) => p.DisplayType !== WebsiteProfileDisplayType.Principal);
    });
  }

  loadOffice(): void {
    switch (Config.Website.Settings!.WebsiteLevel) {
      case WebsiteLevel.Profile:
        API.Profiles.Get(Config.Website.Settings!.WebsiteId, true).then(
          (profile) => {
            this.office = profile.Office;
          },
        );

        break;
      case WebsiteLevel.Office:
        API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
          this.office = office;

          this.mapSettings = new MapSettings({
            Markers: [
              new MapMarker({
                Address: `${this.office.AddressLine1} ${this.office.AddressLine2}`,
                Title: this.office.FranchiseName,
                Coordinate: {
                  Lat: -16.8124155,
                  Lon: 145.7204185,
                },
              }),
            ],
          });
        });

        break;
      default:
        Logger.Log(
          LogLevel.Error,
          'Failed to load office for website. Website level is invalid.',
        );
        break;
    }
  }
}
